module.exports = __webpack_public_path__ + "img/icon_housekeeping.7c48db86.png";